import { Dialog, DialogContent } from "~/components/ui/dialog";
import { Spinner } from "~/components/ui/spinner";

interface ModalLoadingDialogProps {
  message?: string;
  onOpenChange: () => void;
}

export function ModalLoadingDialog({
  message = "Loading...",
  onOpenChange,
}: ModalLoadingDialogProps) {
  return (
    <Dialog onOpenChange={onOpenChange} open>
      <DialogContent>
        <div className="flex flex-col items-center justify-center gap-3 py-8 text-center">
          <Spinner className="size-6" />
          <p className="body-sm text-muted-foreground">{message}</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
